var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSchnellTrocknend2030Min = function SvgSchnellTrocknend2030Min(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Schnell-trocknend_20_-_30_Min_svg__Ebene_2",
    viewBox: "0 0 114.47 114.49"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Schnell-trocknend_20_-_30_Min_svg__cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schnell-trocknend_20_-_30_Min_svg__Layer_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 57.22,
    cy: 57.25,
    r: 38.19,
    className: "Schnell-trocknend_20_-_30_Min_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.22 13.38V1.5M79.3 19.35l5.98-10.27M95.38 35.62l10.34-5.87M101.09 57.77l11.88.14M94.87 79.78l10.19 6.1M78.41 95.67l5.74 10.4M56.19 101.11l-.27 11.88M34.26 94.64l-6.22 10.12M18.56 77.99 8.09 83.61M13.38 55.72 1.5 55.3M20.11 33.85l-10.05-6.33M36.93 18.35 31.44 7.82",
    className: "Schnell-trocknend_20_-_30_Min_svg__cls-1"
  }))));
};
export default SvgSchnellTrocknend2030Min;